import { Link } from 'react-router';

import { dayOf, describe } from '../../dates';
import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// The Dashboard's card of submitted tests the clinician has not reviewed,
// with how many there are, newest first; each opens its review.
export function QuestionnairesToReview({ tests }) {
  const { text, language } = useLanguage();

  let rows = <p className={ styles.empty }>{ text.nothingToReview }</p>;

  if (tests.length > 0) {
    rows = tests.map(function({ attemptId, patientId, patientName, questionnaire, submittedAt }) {
      return (
        <Link key={ attemptId } className={ styles.row } to={ `/patients/${ patientId }/tests/${ attemptId }` }>
          <span className={ styles.lines }>
            <span className={ styles.who }>{ patientName }</span>
            <span className={ styles.detail }>{ `${ questionnaire } · ${ text.submittedLower.replace('{date}', describe({ day: dayOf(submittedAt), language, short: true })) }` }</span>
          </span>

          <span className={ styles.chevron } aria-hidden='true'></span>
        </Link>
      );
    });
  }

  return (
    <section className={ styles.card } aria-labelledby='questionnaires-to-review'>
      <h2 id='questionnaires-to-review' className={ styles.heading }>
        { text.questionnairesToReview } <span className={ styles.count }>· { tests.length }</span>
      </h2>

      { rows }
    </section>
  );
}
